import { styled, Typography } from '@mui/material'
import drop from '../../assets/drop.png'

const Drop = styled('img')({
  width: 50,
  marginBottom: 32,
  marginTop: 16,
})

const Title = ({ title }) => (
  <>
    <Typography color="secondary" variant="h1" paragraph>
      {title}
    </Typography>
    <Drop src={drop} alt="Awa raindrop icon" />
  </>
)

export default Title
